<template lang="pug">
    .w-100.flex.flex-column.justify-center.items-center.bg-white.p-1.rounded-sm
      tutorial-modal(view="Envíos")
        template(v-slot:default)
          b-container
            p Aquí puedes configurar puntos de recolección y/o establecer un costo de envío.
            h5 Envíos
            ul 
              li Agrega un costo de envío único para todos los pedidos. El costo se suma al total de la orden.
              li Por el momento solo se puede establecer un costo de envío.
              li Si no cobras el envío o ya viene incluido en los productos, activa la opción de envíos y establece costo 0 (cero).
              li Si no haces envíos, apaga la opción.
            b-img.mb-3(src="@/assets/tutorial/delivery.png", fluid, rounded, center, width="400")
            h5 Recolección
            ul 
              li Permite establecer puntos de recolección para que tus clientes recogan sus productos.
              li Establece horarios y días disponibles para recolección.
              li La dirección del punto de recolección le aparece al cliente en Google Maps.
              li En la sección Ventas aparece el punto seleccionado en detalles de la orden.
              li Puedes crear tantos puntos de recolección requieras.
              li Si no tienes puntos de recolección, simplemente apaga el switch de Puntos de entrega.
            b-img.mb-3(src="@/assets/tutorial/pickup.png", fluid, rounded, center, width="400")
      b-modal(v-model="deliveryTypeModal", title="Cambiar tipo de envío", :ok-title="isAlreadyEnabled ? 'Ya habilitado' : 'Continuar'", cancel-variant="secondary", cancel-title="Cancelar", ok-variant="primary", @ok="associateEcommerce(changeDeliveryType)" @cancel="EventBus.$emit('changeDeliveryTypeCanceled')", no-close-on-backdrop, no-close-on-esc, hide-header-close, :ok-disabled="isAlreadyEnabled")
        div(v-if="changeDeliveryType != null")
          p Estás por cambiar el tipo de envío a {{ changeDeliveryType.rename }}
          div(v-if="changeDeliveryType.name == 'Basic'")
            p Establece un costo de envío fijo para todas las órdenes. Este tipo de envío es ideal si tú te encargas de hacer los envíos.
            p También puedes establecer puntos de recolección donde tus clientes pueden pasar a recoger sus productos.
            p ¿Cómo funciona?
            ul
              li El Chatbot agrega el costo de envío fijo al total de la orden.
              li Si configuraste puntos de entrega, tu cliente selecciona el punto de recolección y el chatbot te notifica dónde recogerá el producto tu cliente.
      router-view(@changeDeliveryType="changeDelyveryTypeWarning")
</template>

<script>
import { EventBus } from '@/helpers/eventBus'
import { createNamespacedHelpers, mapActions } from 'vuex'
const deliveryController = createNamespacedHelpers('delivery')

import KanguroInfo from '@/components/KanguroInfo.vue'
import TutorialModal from '@/components/TutorialModal.vue'

export default {
  components: {
    TutorialModal,
    KanguroInfo
  },
  data: function () {
    return {
      changeDeliveryType: null,
      deliveryTypeModal: false,
      EventBus: EventBus
    }
  },
  computed: {
    ...deliveryController.mapState({
      // delivery_types: state => state.delivery_types,
      ecommerce_data: state => state.ecommerce_data
    }),
    isAlreadyEnabled() {
      try {
        return this.ecommerce_data.delivery_type_id == this.changeDeliveryType.delivery_type_id
      } catch (e) {
        return false
      }
    }
    // parsed_delivery_types () {
    //   return this.delivery_types.map(d => {
    //     switch (d.name) {
    //       case 'Basic':
    //         d.path = 'Shipping'
    //         d.rename = 'Envíos costo fijo'
    //         break
    //       case 'Kanguro':
    //         d.path = 'Recolection'
    //         d.rename = 'Envíos Kanguro'
    //         break
    //     }
    //     return d
    //   })
    // }
  },
  methods: {
    ...mapActions(['delivery/all', 'delivery/associateEcommerce', 'delivery/ecommerce']),
    getDeliveryTypes() {
      let self = this

      this['delivery/all']({
        account_id: self.$route.params.account_id,
        callback: res => {
          if (res.error) {
            self.$message.error(res.error)
          }
        }
      })
    },
    associateEcommerce({ delivery_type_id, path }) {
      var self = this

      this['delivery/associateEcommerce']({
        account_id: self.$route.params.account_id,
        delivery_type_id: delivery_type_id,
        callback: res => {
          if (res.error) {
            self.$message.error(res.error)
          } else {
            // this.$router.push({name: path})
            // this.getDeliveryTypes()
            window.location.reload()
          }
        }
      })
    },
    changeDelyveryTypeWarning(delivery_type) {
      // if(this.ecommerce_data.delivery_type_id == delivery_type.delivery_type_id) return
      this.changeDeliveryType = delivery_type
      this.deliveryTypeModal = true
      // this.$bvModal.msgBoxConfirm('¿Deseas cambiar el tipo de envío para entregar tus productos? Debes registar puntos de recolección para cada tipo de envío.', {
      //   title: 'Cambiar tipo de envío',
      //   okVariant: 'success',
      //   okTitle: 'Cambiar',
      //   cancelTitle: 'Cerrar'
      // })
      //   .then(value => {
      //     if (value == true) {
      //       this.associateEcommerce(delivery_type)
      //     }
      //   })
      //   .catch(err => {
      //     // An error occurred
      //   })
    },
    geteEcommerceData() {
      let self = this

      this['delivery/ecommerce']({
        account_id: self.$route.params.account_id,
        callback: res => {
          if (res.error) {
            self.$message.error(res.error)
          }
        }
      })
    },
  },
  mounted() {
    this.getDeliveryTypes()
    // this.geteEcommerceData()
  }
}
</script>

<style lang="scss" scoped>
</style>
